<template>
    <template v-if="error">
        <Error503 v-if="error.statusCode === 503"/>
        <component v-else-if="error.statusCode === 404" :is="config.public.websiteId === 'spm' ? SPM : StoneXBullion">
            <Error404 />
        </component>
        <Error403 v-else-if="error.statusCode === 403"/>
        <Error401 v-else-if="error.statusCode === 401"/>
        <ErrorPage v-else/>
    </template>
</template>

<script setup>
import Error503 from "~/errors/Error503.vue";
import Error404 from '~/errors/Error404.vue';
import Error403 from '~/errors/Error403.vue';
import Error401 from "~/errors/Error401.vue";
import ErrorPage from '~/errors/ErrorPage.vue';
import SPM from '~/layouts/spm.vue';
import StoneXBullion from '~/layouts/default.vue';

const config = useRuntimeConfig();

const error = useError();
</script>
